export default function WhyParticipate() {
  const benefits = [
    {
      icon: 'ri-user-search-line',
      title: 'Avaliação Profissional',
      description: 'Feedback de especialistas sobre seu potencial real no mercado.',
    },
    {
      icon: 'ri-star-line',
      title: 'Oportunidade Real',
      description: 'Acesso direto a trabalhos em moda, publicidade e entretenimento.',
    },
    {
      icon: 'ri-building-line',
      title: 'Ambiente Profissional',
      description: 'Seletiva real com estrutura completa e equipe qualificada.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Desenvolvimento Artístico',
      description: 'Orientação profissional e networking para sua carreira.',
    },
  ];

  return (
    <section className="py-16 sm:py-20 bg-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-3 px-4">
            <a href="#beneficios">
              Por Que{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">
                Participar
              </span>
            </a>
          </h4>
          <p className="text-base sm:text-lg text-gray-400 max-w-xl mx-auto">
            Mais do que uma seletiva. Uma porta para o mercado.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-6 sm:p-8 border border-yellow-500/20 hover:border-yellow-500 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex items-start gap-4 sm:gap-5">
                <div className="w-12 h-12 sm:w-13 sm:h-13 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${benefit.icon} text-xl sm:text-2xl text-black`}></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-1.5">{benefit.title}</h3>
                  <p className="text-gray-400 text-sm sm:text-base leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}